module.exports = __webpack_public_path__ + "img/people-icon.d3569f2a.png";